var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { useStoreState } from "pullstate";
import useAuthService from "../../hooks/useAuthService";
import Store from "../../utils/Store";
import { getAppConfig, getUserSettings } from "../../services";
import { useRouter } from "next/router";
import constants from "../../utils/constants";
import { useTranslation } from "react-i18next";
import { initMixpanel, trackEvent, initializeCountly } from "../../utils/mixpanel";
import Loader from "../Loader";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import getEnv from "../../utils/getEnv";
var Authenticator = function Authenticator(props) {
  var children = props.children;
  var _useAuthService = useAuthService(true),
    authData = _useAuthService.data,
    isError = _useAuthService.isError,
    isLoading = _useAuthService.isLoading,
    refetch = _useAuthService.refetch;
  var isLoggedIn = !isError && get(authData, ["authenticated"], false);
  var router = useRouter();
  var _useState = useState(null),
    urlAuthToken = _useState[0],
    setUrlAuthToken = _useState[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        appConfig: s.appConfig,
        userSettings: s.userSettings
      };
    }),
    appConfig = _useStoreState.appConfig,
    userSettings = _useStoreState.userSettings;
  var allowAppLoad = isLoggedIn && appConfig && userSettings;
  var _useTranslation = useTranslation("loading_key", {
      useSuspense: false
    }),
    ready = _useTranslation.ready;
  useEffect(function () {
    if (router.isReady) setUrlAuthToken(router.query.url_auth_token);
  }, [router.isReady]);
  useEffect(function () {
    var _agreement, _agreement2;
    if (!isLoggedIn) {
      return;
    }

    // this query param is set inside termsandconditionsmodal
    var query = router.query;
    if (query.invalidate) {
      refetch();
    }
    var currentVersion = constants.TERMS_OF_USE_VERSION;
    // WARNING: stop gap solution. must be reverted in next release
    var stopGapCheck = currentVersion === "2.0.0" && ((_agreement = authData.agreement) === null || _agreement === void 0 ? void 0 : _agreement.version) === "2.0.4";
    var isCurrentVersion = ((_agreement2 = authData.agreement) === null || _agreement2 === void 0 ? void 0 : _agreement2.version) === currentVersion || stopGapCheck;
    // const isCurrentVersion = ((authData as any).agreement?.version === currentVersion)
    if ((!authData || isCurrentVersion) && router.pathname === "/terms-and-conditions") {
      router.push("/");
      return;
    }
    if (!isCurrentVersion && router.pathname !== "/terms-and-conditions" && router.pathname !== "/open-app") {
      router.push("/terms-and-conditions");
    }
  }, [authData, isLoggedIn, router]);
  useEffect(function () {
    if (isLoggedIn) {
      getUserSettings();
      getAppConfig();
      if (authData) {
        initMixpanel()(authData);
        initializeCountly()(authData);
        trackOTPLogin();
      }
    }
  }, [isLoggedIn]);
  var trackOTPLogin = function trackOTPLogin() {
    var otpLoginSuccess = localStorage.getItem(constants.PERSISTED.otpLoginSuccess);
    if (otpLoginSuccess === "true") {
      localStorage.removeItem(constants.PERSISTED.otpLoginSuccess);
      trackEvent(MIXPANEL_EVENTS.OTP_LOGIN_SUCCESS);
    }
  };
  if (isLoggedIn) {
    var _window;
    localStorage.removeItem("redirectLogin");
    if ((_window = window) !== null && _window !== void 0 && _window.ReactNativeWebView) {
      var _window2;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.ReactNativeWebView) === null || _window2 === void 0 || _window2.postMessage(JSON.stringify({
        event: constants.RN_COMM_CONST.FLUSH_COOKIES
      }));
    }

    // desktop app integration
    if (window.electronAPI) {
      window.electronAPI.setAPISettings({
        apiURL: getEnv("NEXT_PUBLIC_API_URL"),
        token: get(authData, ["token"], null)
      });
    }
    if (router.pathname === "/landing-page") {
      router.push("/");
      return null;
    }
  }
  if ((allowAppLoad || router.pathname === "/landing-page" || router.pathname === "/open-app" || router.pathname === "/notifications-widget" || router.pathname === "/auth/login" || urlAuthToken) && !isLoading && ready) {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center bold text-white sm:text-black sm:dark:text-white sm:bg-gray-100 bg-gray-900 sm:dark:bg-gray-900 w-full h-full"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: "Loading..."
  }));
};
export default Authenticator;